module.exports = __webpack_public_path__ + "static/clap-6d74ef366aa42493acd24740b769c5f9.mp3";